Vue.component('events-data-grid', {

    props: ['events'],

    ready: function () {
    },

    data: function () {
        return {};
    },

    computed: {},

    methods: {}
});



// WEBPACK FOOTER //
// ./resources/assets/js/events/admin/all-data-grid.js